
<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h2 class="card-title mb-4">クーポン検索</h2>
            <CAlert color="success" class="mx-3" v-if="successAlert">更新が完了しました。</CAlert>
            <CForm
              class="search-filter"
              @submit.prevent
            >
              <CRow class="mb-2 ml-2">
                <CCol lg="5">
                  <div class="form-group form-row">

                    <label class="col-form-label col-sm-3">クーポンコード</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        ref="typeBox"
                        placeholder="クーポンのQRコードを読み取ってください（直接入力も可能）"
                        class="form-control"
                        autofocus
                        v-model="CouponCodeIn"
                        @input="searchCoupon"
                      />
                      <!-- @keydown.enter="updateCheck()" -->

                      <div
                        class="text-danger input-info"
                        v-if="
                      (!$v.CouponCodeIn.minLength ||
                        !$v.CouponCodeIn.maxLength)
                    "
                      >
                        6桁のクーポンコードを入力してください
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol
                  lg="2"
                  sm="4"
                >
                  <div
                    class="form-group form-row"
                    v-if="isLoad"
                  >

                    <label class="col-form-label pr-4">ステータス</label>
                    <CAlert
                      :color="couponData.status==1?'success':couponData.status==100? 'danger':'secondary'"
                      class="py-1 px-3 ml-2"
                    >
                      {{couponData.status | CouponStatus}}
                    </CAlert>
                  </div>
                </CCol>
                <CCol
                  lg="2"
                  sm="4"
                >
                  <div
                    class="form-group form-row"
                    v-if="isLoad"
                  >
                    <label class="col-form-label pr-4">使える回数</label>
                    <strong class="px-2 px-4 mt-1  h3">
                      {{couponData.count}}
                    </strong>
                  </div>

                </CCol>
                <CCol
                  lg="2"
                  sm="4"
                >
                  <div
                    class="form-group form-row"
                    v-if="isLoad"
                  >
                    <label class="col-form-label pr-4">使用回数</label>
                    <CInput
                      type="number"
                      class="use-c"
                      v-model="userCoupon"
                    />
                    <div
                      class="text-danger input-info"
                      v-if="!$v.userCoupon.between"
                    >
                      Must be between {{$v.userCoupon.between.min}} and {{$v.userCoupon.between.max}}
                    </div>
                  </div>

                </CCol>
                <CCol
                  lg="1"
                  sm="4"
                  class="text-center"
                >
                  <CButton
                    color="success"
                    class="px-4"
                    v-if="couponData.status == 1"
                    @click="UpdateCouponStatus()"
                  >

                    <i class="icon cil-gift"></i>
                    使う
                  </CButton>
                </CCol>
              </CRow>
              <CRow class="ml-2" v-if="isLoad">
                <CCol>
                  <CButton
                    @click="clearSearch()"
                    color="info"
                  ><i class="icon cil-reload"></i> クリア</CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardHeader>
        </CCard>
      </CCol>
    </CRow>
    <transition name="slide">
      <CRow v-if="isLoad">
        <CCol lg="12">
          <CCard>
            <CCardHeader>
              <h3 class="card-title">クーポン情報</h3>
            </CCardHeader>
            <CCardBody>
              <CCard
                class="shadow-sm"
                body-wrapper
              >
                <CCardBody>
                  <CRow>
                    <CCol class="d-flex">
                      <CCard class="w-25 mr-2 ">
                        <CCardHeader class="bg-dark text-white">
                          <strong>会員情報</strong>
                        </CCardHeader>
                        <CCardBody class="member-c-info">
                          <CRow>
                            <CCol>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">カードID</dt>
                                <dd class="col-sm-8">{{ couponData.cardId }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">会員ID</dt>
                                <dd class="col-sm-8">{{ couponData.userid }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">氏名 (カナ)</dt>
                                <dd class="col-sm-8">{{ `${couponData.familyName} ${couponData.givenName} (${couponData.firstName} ${couponData.lastName}) ` }}</dd>
                              </dl>

                            </CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>

                      <CCard class="w-75 ml-2">
                        <CCardHeader class="bg-dark text-white">
                          <strong>クーポン情報</strong>
                        </CCardHeader>
                        <CCardBody class="coupon-info">
                          <CRow>
                            <CCol>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">クーポンコード</dt>
                                <dd class="col-sm-8">{{ couponData.shortCode }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">SKU</dt>
                                <dd class="col-sm-8">{{ couponData.sku }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">利用回数</dt>
                                <dd class="col-sm-8">{{ couponData.used }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">発券時刻</dt>
                                <dd class="col-sm-8">{{ couponData.activated | formatTime}}</dd>
                              </dl>

                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">金額・割引率</dt>
                                <dd class="col-sm-8">{{ couponData.value }}</dd>
                              </dl>

                              <!-- <dl class="row sub-r-content">
                                <dt class="col-sm-4">回数</dt>
                                <dd class="col-sm-8">{{ couponData.count }}</dd>
                              </dl> -->
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">利用最低金額</dt>
                                <dd class="col-sm-8">{{ couponData.miniPrice }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">画像</dt>
                                <dd class="col-sm-8">
                                  <img
                                    class="coupon-img"
                                    :src="couponData.picture"
                                    alt="クーポン画像"
                                  />
                                </dd>
                              </dl>
                            </CCol>
                            <CCol>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">クーポン名</dt>
                                <dd class="col-sm-8">{{ couponData.name }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">クーポン説明</dt>
                                <dd class="col-sm-8">{{ couponData.description }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">オプション名</dt>
                                <dd class="col-sm-8">{{ couponData.optionName }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">オプション説明</dt>
                                <dd class="col-sm-8">{{ couponData.optionDescription }}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">利用開始日</dt>
                                <dd class="col-sm-8">{{ couponData.validateSince | formatDate}}</dd>
                              </dl>
                              <dl class="row sub-r-content">
                                <dt class="col-sm-4">利用終了日</dt>
                                <dd class="col-sm-8">{{ couponData.validateUntil | formatDate}}</dd>
                              </dl>
                            </CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>

            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </transition>
    <CModal
      color="success"
      size="lg"
      closeOnBackdrop
      :show.sync="successModal"
    >
      更新が完了しました。
      <template #header>
        送信完了
      </template>
      <template #footer>
        <CButton
          @click="successModal = false"
          color="success"
        ><i class="icon cil-x"></i> 閉じる</CButton>
      </template>
    </CModal>
    <CModal
      color="danger"
      size="lg"
      closeOnBackdrop
      :show.sync="errorModal"
    >
      {{errorMessage}}
      <template #header>
        エラー
      </template>
      <template #footer>
        <!-- <CButton @click="activeCoupon(getCoupon.id, option.id)" color="success" -->
        <CButton
          @click="errorModal = false"
          color="danger"
          class="px-3"
        >x</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import { minLength, maxLength, between } from "vuelidate/lib/validators";

export default {
  name: "CouponOperation",
  data() {
    return {
      isLoad: false,
      successModal: false,
      successAlert: false,
      errorModal: false,
      couponData: {},
      CouponCodeIn: "",
      errorMessage: "",
      maxCouponUse: 1,
      userCoupon: 0,
    };
  },

  created() {},
  validations() {
    var maxCUser = this.maxCouponUse;
    return {
      CouponCodeIn: {
        minLength: minLength(6),
        maxLength: maxLength(6),
      },
      userCoupon: {
        between: between(1, maxCUser),
      },
    };
  },
  filters: {},

  methods: {
    clearSearch() {
      this.$refs.typeBox.focus()
      this.CouponCodeIn = "";
      this.isLoad = false;
      this.successAlert = false;
      this.couponData={};
    },
    searchCoupon(event) {
      var inputedC = event.target.value;
      inputedC.length == 6
        ? this.getCouponInfo(inputedC)
        : (this.isLoad = false);
    },
    getCouponInfo(couponCode) {
      var urlRequest = "/rest/coupon/ticket/code/" + couponCode;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.couponData = resp.data;
          this.isLoad = true;
          this.userCoupon = this.couponData.count;
          this.maxCouponUse = this.couponData.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    UpdateCouponStatus() {
      var urlRequest =
        "/rest/coupon/ticket/code/" + this.couponData.shortCode + "/status";
      var reqStatus = {
        status: 99,
      };
      axios
        .put(urlRequest, reqStatus, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          this.successAlert = true;
          this.couponData = resp.data;
          this.getCouponInfo(this.couponData.shortCode);
        })
        .catch((err) => {
          this.errorMessage = err.response.status;
          this.errorModal = true;
        });
    },
  },
  beforeMount() {
    // this.getCouponInfo();
  },
};
</script>
<style lang="scss" scoped>
.use-c {
  display: inline-block;
  max-width: 70px;
  margin-left: 0.5em;
}
</style>
